<template>
  <div class="scrollable" v-loading.fullscreen.lock="fullscreenLoading">
    <v-header></v-header>
    <div class="content">
      <div class="breadNav">
        <P>健康管理 > 体检订单 > 订单详情</P>
      </div>
      <div class="user" :class="details.status == 7 ? 'user2' : ''">
        <!-- <p class="icon"></p> -->
        <p class="name">
          {{ $t("m.phyOrderDetails.orderStatus") }}：
          <span
            :class="
              details.status == 0
                ? 'status1'
                : details.status == 2
                ? 'status2'
                : details.status == 3
                ? 'status3'
                : details.status == 4 ||
                  details.status == 1007 ||
                  details.status == 1003
                ? 'status4'
                : details.status == 1 || details.status == 7
                ? 'status5'
                : details.status == 5
                ? 'status6'
                : 'status7'
            "
            >{{ details.status_text }}</span
          >
        </p>
        <!-- <p class="idCard" style="margin-left: 40px;">
          {{$t('m.phyOrderList.orderItem.orderNum')}}：
          <span>{{details.order_no}}</span>
        </p>
        <p class="phone">
          {{$t('m.phyOrderList.orderItem.orderTime')}}：
          <span>{{details.create_time}}</span>
        </p> -->
        <div
          style="
            float: right;
            margin-left: 750px;
            color: #ff000f;
            font-size: 18px;
            font-weight: 600;
          "
        >
          <p v-if="details.status == 1000">
            <span>{{ $t("m.phyOrderList.orderItem.payCountdown") }}：</span>
            {{ details.hh }} : {{ details.mm }} : {{ details.ss }}
          </p>
        </div>
        <div v-if="details.status == 7" class="hint">
          您的体检服务已取消，支付金额将在7个工日内原路退回
        </div>
      </div>
      <div class="user" v-if="details.person">
        <!-- <p class="icon"></p> -->
        <p class="name">
          {{ $t("m.phyOrderList.titList.username") }}：{{ details.person.name }}
        </p>
        <p class="sex">{{ details.person.gender_value }}</p>
        <p class="idCard">
          {{ $t("m.phyOrderDetails.cardNum") }}：
          <span>{{ details.person.identity_code }}</span>
        </p>
        <p class="phone">
          {{ $t("m.phyOrderDetails.phone") }}：
          <span>{{ details.person.contacttel }}</span>
        </p>
      </div>
      <!-- 体检机构及时间 -->
      <div class="hospitalTime" v-if="details.status != 0">
        <div class="tit">
          <!-- <p class="icon"></p> -->
          <p v-if="details.hospital.area.name">
            体检城市：{{ details.hospital.area.name }}
          </p>
        </div>
        <div class="tit" style="margin-top: 15px">
          <p>
            机构分院：{{ details.hospital.name }}
            <span
              style="
                cursor: pointer;
                text-decoration: underline;
                margin-left: 10px;
                color: #ff000f;
                font-size: 14px;
              "
              @click="getHosMsg"
              >查看分院详情</span
            >
          </p>
        </div>
        <div style="margin: 17px 0 17px 96px">
          <!-- <el-rate v-model="details.hospital.star" value="details.hospital.star" disabled style="margin-right: 5px;float: left; "></el-rate> {{ $t("m.staffMsg.grade") }} -->
          <!-- <span style="color: #FF000F;">{{ details.hospital.star }}</span> -->
        </div>
        <div
          style="
            margin-left: 96px;
            color: #666666;
            font-size: 16px;
            margin-bottom: 15px;
          "
        >
          {{ details.hospital.address }}
        </div>
        <div class="tit">
          <p>{{ $t("m.phyOrderDetails.time") }}：{{ details.exam_date }}</p>
        </div>
        <div class="line"></div>
        <div
          id="package"
          
        >
          <div v-if="details.combo">
            <!-- <p class="icon"></p> -->
            <p style="color: #333; font-size: 18px; font-weight: 600">
              <span>常规项目：</span>{{ details.combo.name }}
              {{ details.combo.description }}
              <span
                @click="getPhyMsg"
                style="
                  cursor: pointer;
                  text-decoration: underline;
                  color: #ff000f;
                  font-size: 14px;
                "
                >{{ $t("m.phyOrderDetails.getMealDetail") }}</span
              >
              <span style="float: right; color: #ff000f"
                >￥{{ details.combo.sell_price }}</span
              >
            </p>
          </div>
          <div
            style="
              margin-top: 15px;
              width: 80px;
              font-weight: bold;
              color: #333;
              font-size: 18px;
            "
            v-if="
            details.extra_exam != undefined &&
            details.extra_exam != null &&
            details.extra_exam.length > 0
          "
          >
            <!-- <p class="icon"></p> -->
            <p style="margin-left: 0">加项包：</p>
          </div>
          <div
            class="hospital"
            :key="index"
            v-for="(item, index) in details.extra_exam"
            style="position: relative; margin-top: 28px"
          >
            <div id="jxService" style="margin-top: -47px">
              <span
                class="city"
                :key="index1"
                v-for="(item1, index1) in item.items"
              >
                {{ item1.name }}
                <span class="jxprice">￥{{ item1.sell_price }}</span>
              </span>
            </div>
          </div>
          <!-- <div class="line"></div> -->
        </div>
      </div>
      <!-- 收货地址 -->
      <div v-if="details.recipient_info">
        <div class="hospitalTime" v-if="details.recipient_info.recipient_name">
          <div class="tit">
            <p class="icon"></p>
            <p>{{ $t("m.staffPhyAckOrder.consigneeTit") }}：</p>
          </div>
          <div class="time">
            <p>{{ $t("m.staffPhyAckOrder.consigneeName") }}：</p>
            <p>{{ details.recipient_info.recipient_name }}</p>
          </div>
          <div class="time">
            <p>{{ $t("m.staffPhyAckOrder.consigneePhone") }}：</p>
            <p>{{ details.recipient_info.recipient_mobile }}</p>
          </div>
          <div class="time">
            <p>{{ $t("m.staffPhyAckOrder.consigneeAddress") }}：</p>
            <p>{{ details.recipient_info.full_address }}</p>
          </div>
        </div>
      </div>

      <div class="user" style="margin-bottom: 20px; position: relative">
        <!-- <p class="icon"></p> -->
        <p class="name">
          实际支付金额：
          <span
            style="color: #ff000f; position: absolute; right: 25px; top: 40%"
            >￥{{ details.paid_money }}</span
          >
        </p>
      </div>

      <div
        class="user"
        v-if="
          details.person.relationship == 0 &&
          details.hospital.report_type == 0 &&
          details.report_authorize == 1&&
          details.hospital.branch_type == 0
        "
      >
        <!-- <i class="icon"></i> -->
        <p class="name">已授权-检后7-10个工作日在线查看电子报告</p>
      </div>
      <div
        class="user3"
        v-if="
          details.person.relationship == 0 &&
          details.hospital.report_type == 0 &&
          details.report_authorize == 0 &&
          details.hospital.branch_type == 0
        "
      >
        <div class="user3_top">
          未授权 - 前台咨询获取纸质报告
          <em
            v-if="
              details.status == 1000 ||
              details.status == 1 ||
              details.status == 2
            "
            >或 -
          </em>
          <b
            v-if="
              details.status == 1000 ||
              details.status == 1 ||
              details.status == 2
            "
            @click="againBtn"
            style="color: #ff000f; cursor: pointer"
            >重新授权</b
          >   
        </div>
        <div
          v-if="
            details.status == 1000 || details.status == 1 || details.status == 2
          "
          class="ts"
        >
          <span>*提示：</span
          >您当前未授权则不能在本平台查询报告，并无法享受报告解读服务；<br /><em
            style="padding-left: 42px"
            >（如选择同意授权，体检报告数据将严格保密，不会产生个人信息暴露）</em
          >
        </div>
      </div>

      <div
        class="user"
        v-if="
          details.person.relationship == 0 &&
          (details.hospital.report_type!=0 || (details.hospital.report_type==0 && details.hospital.branch_type==1))
        "
      >
        <!-- <i class="icon"></i> -->
        <p class="name">
          该分院不支持在本平台查看体检报告，报告获取方式请在体检结束后向前台咨询
        </p>
      </div>
      <div class="user" v-if="details.person.relationship != 0">
        <!-- <i class="icon"></i> -->
        <p class="name">
          因体检报告为个人隐私，本平台暂无法提供家属体检报告查询功能。
        </p>
      </div>

      <div class="integral">
        <div class="left">
          <p v-if="details.status == 1000">
            <span>{{ $t("m.phyOrderList.orderItem.payCountdown") }}：</span>
            {{ details.hh }} : {{ details.mm }} : {{ details.ss }}
          </p>
        </div>
        <div class="right" v-if="details.status == 1000">
          <p class="cancel" @click="cancelOrder" v-if="details.can_cancel">
            {{ $t("m.phyOrderList.orderItem.cancelOrder") }}
          </p>
          <p class="submit" @click="pay">
            {{ $t("m.phyOrderList.orderItem.immediatePayment") }}
          </p>
        </div>
        <div class="right" v-if="details.status == 0">
          <p class="cancel" @click="cancelOrder" v-if="details.can_cancel">
            {{ $t("m.phyOrderList.orderItem.cancelOrder") }}
          </p>
          <p class="submit" @click="immediateAppointment">
            {{ $t("m.phyOrderList.orderItem.immediateAppointment") }}
          </p>
        </div>
        <div class="right" v-if="details.status == 1 || details.status == 3">
          <p class="cancel" @click="cancelOrder" v-if="details.can_cancel">
            {{ $t("m.phyOrderList.orderItem.cancelOrder") }}
          </p>
          <p class="submit" @click="changeTime" v-if="details.can_change">
            {{ $t("m.phyOrderList.orderItem.appointmentRescheduling") }}
          </p>
        </div>
        <div
          class="right"
          v-if="details.status == 2 && details.person.relationship === 0"
        >
          <p class="cancel"></p>
          <p class="submit" @click="degree">
            {{ $t("m.phyOrderList.orderItem.degree") }}
          </p>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
    <!-- 查看套餐详情 -->
    <div id="interpret">
      <el-dialog
        :visible.sync="combointerpretVisible"
        :close-on-click-modal="false"
      >
        <div
          v-if="comboDetailLoading"
          style="width: 100%; display: flex; justify-content: center"
        >
          <p style="font-size: 16px; color: #333">{{ $t("m.common.load") }}</p>
        </div>
        <div v-if="!comboDetailLoading" class="interpretMsg">
          <div class="mealName">
            <p class="icon"></p>
            <p class="name">
              {{ $t("m.staffMsg.mealList") }}：{{ datajson.name }}
              {{ datajson.description }}
            </p>
            <p class="msg">
              {{ $t("m.staffMealDetail.mealNum1")
              }}{{ datajson.check_item_count
              }}{{ $t("m.staffMealDetail.mealNum2")
              }}{{ $t("m.staffMealDetail.mealNum3") }}
            </p>
          </div>
          <p
            style="
              font-size: 14px;
              line-height: 26px;
              margin-top: 20px;
              color: #ff000f;
            "
          >
            温馨提示：由于各体检中心/医院设备及检验方式不同，体检套餐中个别项目会略有调整，具体请以体检中心/医院为准。
          </p>
          <div
            class="details"
            :key="index"
            v-for="(item, index) in datajson.items"
          >
            <div class="tit">
              <p>{{ item.name }}</p>
            </div>
            <el-table :data="item.items" border stripe style="width: 100%">
              <el-table-column
                prop="name"
                :label="$t('m.staffMealDetail.medicalItems')"
              ></el-table-column>
              <el-table-column
                prop="clinic_mean"
                :label="$t('m.staffMealDetail.examinationSignificance')"
              ></el-table-column>
              <el-table-column
                prop="content"
                :label="$t('m.staffMealDetail.checkItems')"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeBtn('combo')">{{
            $t("m.common.closeBtn")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 查看分院详情弹窗 -->
    <div id="interpret">
      <el-dialog :visible.sync="interpretVisible" :close-on-click-modal="false">
        <div
          v-if="hosDetailLoading"
          style="width: 100%; display: flex; justify-content: center"
        >
          <p style="font-size: 16px; color: #333">{{ $t("m.common.load") }}</p>
        </div>
        <div v-if="!hosDetailLoading" class="interpretMsg">
          <div class="hospitalName">
            <p class="icon"></p>
            <p class="name">
              {{ $t("m.staffHosDetail.hos") }}：{{ datajson.name }}
            </p>
          </div>
          <div class="map" id="XSDFXPage"></div>
          <div class="mapMsg">
            <p>
              <span>{{ $t("m.staffHosDetail.address") }} :</span>
              <span>{{ datajson.address }}</span>
            </p>
            <p>
              <span>{{ $t("m.staffHosDetail.time") }} :</span>
              <span>{{ datajson.work_time }}</span>
            </p>
            <!-- <p><span>{{$t('m.staffHosDetail.phone')}} : </span><span>{{datajson.inst_contact}} </span></p> -->
            <!-- <p>
              <span>{{$t('m.staffHosDetail.msg')}} :</span>
              <span>{{datajson.description}}</span>
            </p>
            <p>
              <span>{{$t('m.staffHosDetail.line')}} :</span>
              <span>{{datajson.traffic_route}}</span>
            </p>-->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeBtn('hos')">{{
            $t("m.common.closeBtn")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 预约改期 -->
    <el-dialog
      :title="$t('m.phyOrderList.orderItem.appointmentRescheduling')"
      :visible.sync="changeTimeVisible"
      :close-on-click-modal="false"
    >
      <div id="changeTime">
        <el-date-picker
          v-model="timeVal"
          type="date"
          @change="getTime"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :placeholder="$t('m.phyOrderList.orderItem.chooseTime')"
          class="chooseTime"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeTimeVisible = false">{{
          $t("m.common.cancelBtn")
        }}</el-button>
        <el-button type="primary" :loading="btnLoading" @click="changeTimeOk">{{
          $t("m.common.define")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 授权报告 -->
    <el-dialog
      :visible.sync="reportVisible"
      :close-on-click-modal="false"
      style="border-radius: 20px"
    >
      <div class="reportMsg">
        <p
          style="
            font-size: 33px;
            margin-bottom: 10px;
            font: bold;
            text-align: center;
            color: #333333;
          "
        >
          体检报告授权协议
        </p>
        <p style="color: #333; font-size: 18px">亲爱的用户，您好！</p>
        <p style="color: #333; font-size: 18px">
          请查看并阅读<a
            style="color: #e51e26; cursor: pointer; text-decoration: underline"
            target="1"
            href="../../../../static/pdf/用户授权协议.pdf"
            >《体检报告授权协议》</a
          >，确定是否同意在本平台查看体检报告。
        </p>
        <p style="font-size: 16px; color: #333">注：</p>
        <p style="font-size: 16px; color: #333; line-height: 25px">
          1.连锁私立体检机构（爱康/美年/瑞慈）默认为电子报告，您授权后即可在本平台查看并使用报告解读等服务；
        </p>
        <p
          style="font-size: 16px; color: #333; margin: 5px 0; line-height: 25px"
        >
          2.和谐健康等其他民营机构的报告的报告，需由各机构指定的方式获取。您获取后，在电脑端上传个人体检报告，方能使用报告解读以及健康评估等服务。
        </p>
        <p style="font-size: 16px; color: #333; line-height: 25px">
          3.公立医院为纸质报告，需自取或团检统一返还，并由您在电脑端上传个人体检报告以后，方能使用报告解读以及健康评估等服务。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reportVisible = false">取消</el-button>
        <el-button type="primary" @click="agreeBtn">{{
          $t("m.common.define")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
    import axios from "axios";
    import {
        mapActions,
        mapGetters
    } from "vuex";
    import header from "../../common/header.vue";
    import footer from "../../common/footer.vue";
    var timeData = [];
    export default {
        name: "phyAckOrder",
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        var year = time.getFullYear(),
                            month = ("0" + (time.getMonth() + 1)).slice(-2),
                            date = ("0" + time.getDate()).slice(-2);
                        var dateStr = year + "-" + month + "-" + date;
                        return timeData.indexOf(dateStr) == -1;
                    },
                },
                details: {},
                // project:{},
                changeTimeVisible: false,
                timeVal: "",
                interpretVisible: false, //分院弹窗是否显示
                datajson: {},
                combointerpretVisible: false, //套餐详情弹窗是否显示
                newDetails: {},
                fullscreenLoading: false,
                btnLoading: false,
                timer: null,
                hosDetailLoading: false,
                comboDetailLoading: false,
                phyPersonType: "",
                reportVisible: false,
                getConfirm: {}
            };
        },
        components: {
            "v-header": header,
            "v-footer": footer,
        },
        created() {
            let _this = this;
            _this.getOrderDetail();
            _this.getConfirm = JSON.parse(sessionStorage.getItem("staffParams"));
            // _this.project = sessionStorage.getItem('project').id;
            console.log(_this.details.report_authorize);
            // _this.phyPersonType = this.$route.query.
        },
        methods: {
            ...mapActions(
                // 语法糖
                ["message"] // 相当于this.$store.dispatch('modifyName'),提交这个方法
            ),
            //查看套餐详情
            getPhyMsg() {
                let _this = this;
                _this.datajson = {};
                _this.combointerpretVisible = true;
                _this.comboDetailLoading = true;
                // let params = _this.getConfirm.paramsJSON;
                let exam_type;
                if (_this.details.person.relationship === 0) {
                    exam_type = "";
                } else {
                    exam_type = "&exam_type=relative";
                }
                // let params = {
                //     project: JSON.parse(sessionStorage.getItem('project')).id,

                // };

                //获取套餐详情接口
                axios
                    .get(
                        BASE_URL +
                        "/exam/hospitals/" +
                        _this.details.hospital.id +
                        "/combos/" +
                        _this.details.combo.id +
                        "/" +
                        "?project=" +
                        _this.details.project.id +
                        exam_type
                    )
                    .then((res) => {
                        _this.comboDetailLoading = false;
                        _this.datajson = res.data.data;
                    })
                    .catch((err) => {
                        _this.comboDetailLoading = false;
                    });
            },
            //查看机构详情
            getHosMsg() {
                let _this = this;
                _this.datajson = {};
                _this.interpretVisible = true;
                _this.hosDetailLoading = true;
                //获取套餐详情接口
                axios
                    .get(
                        BASE_URL +
                        "/exam/hospitals/" +
                        _this.details.hospital.id +
                        "/", {
                            params: {
                                project: _this.details.project.id,
                            },
                        }
                    )
                    .then((res) => {
                        _this.hosDetailLoading = false;
                        _this.datajson = res.data.data;
                        setTimeout(function() {
                            _this.setMap();
                        }, 100);
                    })
                    .catch((err) => {
                        _this.hosDetailLoading = false;
                    });
            },
            //关闭按钮
            closeBtn(type) {
                let _this = this;
                if (type == "combo") {
                    _this.combointerpretVisible = false;
                } else {
                    _this.interpretVisible = false;
                }
            },
            //取消订单
            cancelOrder() {
                let _this = this;
                _this
                    .$confirm(_this.$t("m.phyOrderList.cancelOrderModal.isCancel"), {
                        confirmButtonText: _this.$t("m.common.define"),
                        cancelButtonText: _this.$t("m.common.cancelBtn"),
                        // type: 'warning'
                    })
                    .then(() => {
                        axios
                            .delete(BASE_URL + "/exam/orders/" + _this.details.order_no + "/")
                            .then((res) => {
                                // console.log(res);
                                let data = {
                                    message: _this.$t("m.phyOrderList.cancelOrderModal.cancelSuss"),
                                    type: "success",
                                    center: true,
                                };
                                _this.message(data);
                                _this.getOrderDetail();
                            });
                    });
            },
            //满意度调查
            degree() {
                // 获取问卷填写状态
                axios
                    .get(BASE_URL + "/exam/survey/abb/is_completed/")
                    .then((res) => {
                        if (!res.data.data.status) {
                            this.$router.push({
                                path: "/investigate",
                                query: {
                                    hospital: this.details.hospital.area.name +
                                        " " +
                                        this.details.hospital.name,
                                    subOrderNo: this.$route.query.order_no,
                                },
                            });
                        } else {
                            this.$message.error("您已提交过满意度调查，请勿重复提交");
                        }
                    })
                    .catch((err) => {});
            },
            //立即支付
            pay() {
                let _this = this;
                window.location.href =
                    pay_URL + "/cashier/pc/?order_no=" + _this.details.order_no;
            },
            //立即预约
            // immediateAppointment(){
            //   let _this = this;
            //     _this.$router.push({
            //       path:'/depSubscribe',
            //       query:{
            //         order_no:_this.details.order_no
            //       }
            //     })
            // },
            //选择时间
            getTime(val) {
                // console.log(val)
                let _this = this;
                _this.timeVal = val;
            },
            //预约改期
            changeTime(comboId, hospitalId, order_no) {
                let _this = this;
                _this.timeVal = "";
                _this.changeTimeVisible = true;
                _this.getHosTime();
            },
            //更换体检日期
            changeTimeOk() {
                let _this = this;
                if (_this.timeVal) {
                    _this.btnLoading = true;
                    axios
                        .put(BASE_URL + "/exam/orders/" + _this.details.order_no + "/", {
                            exam_date: _this.timeVal,
                        })
                        .then((res) => {
                            // console.log(res);
                            _this.btnLoading = false;
                            _this.changeTimeVisible = false;
                            let data = {
                                message: _this.$t("m.phyOrderList.orderItem.appointmentSuccess"),
                                type: "success",
                                center: true,
                            };
                            _this.message(data);
                            _this.getOrderDetail();
                            // _this.getComboDetail();
                        })
                        .catch((err) => {
                            _this.btnLoading = false;
                        });
                } else {
                    _this.$message.error("请选择日期");
                }
            },
            againBtn() {
                this.reportVisible = true;
            },
            //重新授权
            agreeBtn() {
                let _this = this;
                _this.fullscreenLoading = true;
                axios
                    .post(`${BASE_URL}/exam/reports/second/authorize/`, {
                        project: _this.details.project.id,
                        order_no: _this.details.order_no,
                        authorize: 1,
                    })
                    .then((res) => {
                        _this.reportVisible = false;
                        _this.fullscreenLoading = false;
                        _this.getOrderDetail();
                    })
                    .catch((err) => {
                        _this.fullscreenLoading = false;
                    });
            },
            //获取可约时间列表
            getHosTime() {
                let _this = this;
                timeData = [];
                axios
                    .get(BASE_URL + "/exam/orders/" + _this.details.order_no + "/schedule/")
                    .then((res) => {
                        console.log(res);
                        let data = res.data.data;
                        data.forEach(function(element) {
                            if (element.maxNum > element.usedNum) {
                                timeData.push(element.regDate);
                            }
                        });
                        _this.pickerOptions = {
                            disabledDate(time) {
                                var year = time.getFullYear(),
                                    month = ("0" + (time.getMonth() + 1)).slice(-2),
                                    date = ("0" + time.getDate()).slice(-2);
                                var dateStr = year + "-" + month + "-" + date;
                                return timeData.indexOf(dateStr) == -1;
                            },
                        };
                    });
            },
            //查看套餐详情
            getComboDetail() {
                let _this = this;
                _this.$router.push({
                    path: "/setMealDetails",
                    query: {
                        id: _this.details.combo.id,
                        project: _this.details.project.id,
                    },
                });
            },
            //跳转机构详情页面
            getHospital() {
                let _this = this;
                _this.$router.push({
                    path: "/hospitalDetails",
                    query: {
                        id: _this.details.hospital.id,
                    },
                });
            },
            //确认预约
            submit() {
                let _this = this;
                _this.$router.push({
                    path: "/successfulAppointment",
                });
            },
            //获取订单详情
            getOrderDetail() {
                let _this = this;
                _this.fullscreenLoading = true;
                _this.newDetails = {};
                //获取订单详情接口
                axios
                    .get(BASE_URL + "/exam/orders/" + _this.$route.query.order_no + "/")
                    .then((res) => {
                        _this.fullscreenLoading = false;
                        _this.details = res.data.data;
                        if (res.data.data.status === 1000) {
                            _this.newDetails = res.data.data;
                            _this.$set(_this.newDetails, "ss", _this.getTimeList());
                        }
                    })
                    .catch((err) => {
                        _this.fullscreenLoading = false;
                    });
            },
            getTimeList() {
                var _this = this;
                _this.timer = setInterval(function() {
                    let a = _this.newDetails.create_time;
                    const b = a.replace(/-/g, "/");
                    let ti = new Date(b).getTime();
                    var start = new Date().getTime();
                    var end = new Date(ti + 1 * 60 * 60 * 1000).getTime();
                    var rightTime = end - start;
                    if (rightTime > 0) {
                        var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
                        var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
                        var mm = Math.floor((rightTime / 1000 / 60) % 60);
                        var ss = Math.floor((rightTime / 1000) % 60);
                        dd = dd > 9 ? dd : "0" + dd;
                        hh = hh > 9 ? hh : "0" + hh;
                        mm = mm > 9 ? mm : "0" + mm;
                        ss = ss > 9 ? ss : "0" + ss;
                        _this.newDetails["dd"] = dd;
                        _this.newDetails["hh"] = hh;
                        _this.newDetails["mm"] = mm;
                        _this.newDetails["ss"] = ss;
                    } else {
                        _this.newDetails["dd"] = 0;
                        _this.newDetails["hh"] = 0;
                        _this.newDetails["mm"] = 0;
                        _this.newDetails["ss"] = 0;
                        _this.getOrderDetail();
                        clearInterval(_this.timer);
                        _this.timer = null;
                    }
                }, 1000);
            },
            // 地图
            setMap() {
                let _this = this;
                //创建Map实例
                var map = new BMap.Map("XSDFXPage");
                // 初始化地图,设置中心点坐标
                var point = new BMap.Point(
                    parseFloat(_this.datajson.longitude),
                    parseFloat(_this.datajson.latitude)
                ); // 创建点坐标
                map.centerAndZoom(point, 15);
                //添加鼠标滚动缩放
                map.enableScrollWheelZoom();

                //添加缩略图控件
                map.addControl(
                    new BMap.OverviewMapControl({
                        isOpen: false,
                        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
                    })
                );
                //添加缩放平移控件
                map.addControl(new BMap.NavigationControl());
                //添加比例尺控件
                map.addControl(new BMap.ScaleControl());
                //添加地图类型控件
                //map.addControl(new BMap.MapTypeControl());

                //设置标注的图标
                var icon = new BMap.Icon(
                    require("../../../assets/icon.png"),
                    new BMap.Size(100, 100)
                );
                //设置标注的经纬度
                var marker = new BMap.Marker(
                    new BMap.Point(
                        parseFloat(_this.datajson.longitude),
                        parseFloat(_this.datajson.latitude)
                    ), {
                        icon: icon,
                    }
                );
                //把标注添加到地图上
                map.addOverlay(marker);
                var content = "<table>";
                // content = content + "<tr><td> 编号：001</td></tr>";
                content = content + "<tr><td> " + _this.datajson.name + "</td></tr>";
                // content = content + "<tr><td> 时间：2018-1-3</td></tr>";
                content += "</table>";
                var infowindow = new BMap.InfoWindow(content);
                marker.addEventListener("click", function() {
                    _this.openInfoWindow(infowindow);
                });

                //点击地图，获取经纬度坐标
                // map.addEventListener("click",function(e){
                //      document.getElementById("aa").innerHTML = "经度坐标："+e.point.lng+" &nbsp;纬度坐标："+e.point.lat;
                //  });
            },
        },
        computed: {
            // ...mapGetters(['resturantName','resturantId']) // 动态计算属性，相当于this.$store.getters.resturantName
        },
        mounted() {
            let _this = this;
            // _this.getTimeList();
        },
    };
</script>

<style scoped>
    .user3 {
        width: 1180px;
        margin: 0 auto;
        border: 1px solid #ccc;
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 30px 0;
        padding-left: 30px;
    }
    
    .user3 .user3_top {
        font-size: 16px;
        font-weight: 600;
    }
    
    .user3 .ts {
        font-size: 16px;
        margin-top: 10px;
    }
    
    .user3 .ts>span {
        font-weight: 600;
        color: #ff000f;
    }
    
    .hospitalName {
        width: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    
    .hospitalName .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .hospitalName .name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .mapMsg {
        width: 100%;
        margin: 0 auto;
        margin-top: 30px;
    }
    
    .mapMsg p span:first-child {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        line-height: 26px;
    }
    
    .mapMsg p span:last-child {
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 26px;
    }
    
    .map {
        width: 100%;
        height: 260px;
        border: 1px solid #ccc;
        margin: 0 auto;
        margin-top: 30px;
        padding: 20px;
    }
    
    .map img {
        width: 100%;
        height: 100%;
    }
    
    .details {
        width: 100%;
        margin: 0 auto;
    }
    
    .details .tit {
        width: 100%;
        height: 46px;
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        background: #ffeeef;
        margin-top: 30px;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }
    
    .details .tit p {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        line-height: 16px;
    }
    
    .mealName {
        width: 100%;
        height: 78px;
        border: 1px solid #ccc;
        margin: 0 auto;
        /*margin-top: 30px;*/
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 30px;
    }
    
    .mealName .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .mealName .name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .mealName .msg {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        margin-left: 10px;
    }
    
    .chooseTime {
        width: 100% !important;
    }
    
    .jxprice {
        font-size: 18px;
        font-weight: 600;
        color: #ff000f;
        float: right;
        line-height: 18px;
        padding-left: 10px;
    }
    
    #jxService {
        display: flex;
        width: 93.8%;
        flex-direction: column;
        /*align-items: center;*/
    }
    /* #jxService .city {
        margin-bottom: 35px;
    } */
    
    #package .hospital {
        height: auto !important;
        display: flex;
        align-items: flex-start;
    }
    
    #jxService span:nth-child(1) {
        margin-top: 0;
    }
    
    .hospitalTime .hospital:nth-child(1) {
        margin-top: 0;
    }
    
    #jxService span {
        display: inline-block;
        margin-top: 10px;
    }
    
    .status1 {
        color: #e51e26;
    }
    
    .status2 {
        color: #1fba80;
    }
    
    .status3 {
        color: #d0021b;
    }
    
    .status4 {
        color: #050404;
    }
    
    .status5 {
        color: #f5a623;
    }
    
    .status6 {
        color: #0057b8;
    }
    
    .status7 {
        color: #ff000f;
    }
    
    .integral {
        width: 1180px;
        height: 46px;
        margin: 20px auto;
        margin-bottom: 70px;
        display: flex;
        justify-content: space-between;
        padding-left: 30px;
        align-items: center;
    }
    
    .integral .left p {
        font-size: 16px;
        font-weight: 600;
        color: #e51e26;
        line-height: 16px;
    }
    
    .integral .left p span {
        color: #333;
    }
    
    .integral .right {
        display: flex;
        align-items: center;
    }
    
    .integral .right .cancel {
        font-size: 18px;
        font-weight: 400;
        color: #ff000f;
        line-height: 18px;
        cursor: pointer;
    }
    
    .integral .right .submit {
        width: 180px;
        height: 46px;
        background: #ff000f;
        display: flex;
        align-items: center;
        border-radius: 23px;
        justify-content: center;
        margin-left: 50px;
        font-size: 20px;
        /*font-weight:600;*/
        color: #fff;
        line-height: 20px;
        cursor: pointer;
    }
    
    .tc {
        width: 1180px;
        border: 1px solid #ccc;
        margin: 0 auto;
        padding: 30px;
        display: flex;
        margin-top: 30px;
        align-items: center;
    }
    
    .tc .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .tc .name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .tc .msg {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        text-decoration: underline;
        cursor: pointer;
        margin-left: 10px;
    }
    
    .hospitalTime .time p:last-child {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 20px;
    }
    
    .hospitalTime .hospital .msg {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        text-decoration: underline;
        margin-left: 10px;
        cursor: pointer;
    }
    
    .hospitalTime .hospital .address {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 16px;
        /*margin-left: 20px;*/
    }
    
    .hospitalTime .hospital .city,
    .hospitalTime .hospital .jg {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 20px;
    }
    
    .hospitalTime .hospital .left p:first-child,
    .hospitalTime .time p:first-child {
        /*width:220px;*/
        font-size: 18px;
        font-weight: 400;
        color: #333;
        line-height: 18px;
        display: flex;
        justify-content: flex-end;
        /*margin-left: 30px;*/
    }
    
    #package .hospital p {
        width: 220px;
        font-size: 18px;
        font-weight: 400;
        color: #333;
        line-height: 18px;
        display: flex;
        justify-content: flex-end;
    }
    
    .hospitalTime .hospital .left,
    .hospitalTime .time p:first-child {
        width: 220px;
    }
    
    .hospitalTime .hospital .right .top {
        display: flex;
    }
    
    .hospitalTime .hospital .right .bottom {
        display: flex;
        margin-top: 20px;
        margin-left: 19px;
    }
    
    .hospitalTime .hospital,
    .hospitalTime .time {
        width: 100%;
        /*height: 18px;*/
        display: flex;
        /*align-items: center;*/
        margin-top: 15px;
        margin-left: 70px;
    }
    
    .hospitalTime {
        width: 1180px;
        margin: 0 auto;
        border: 1px solid #ccc;
        padding: 30px;
        margin-top: 30px;
    }
    
    .hospitalTime .tit {
        display: flex;
        align-items: center;
    }
    
    .hospitalTime .tit .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .hospitalTime .tit p:last-child {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        /* margin-left: 7px; */
    }
    
    .user {
        width: 1180px;
        height: 78px;
        margin: 0 auto;
        border: 1px solid #ccc;
        margin-top: 30px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        position: relative;
    }
    
    .user1 {
        width: 1180px;
        height: 144px;
        margin: 0 auto;
        border: 1px solid #ccc;
        margin-top: 30px;
        position: relative;
        /* display: flex; */
        /* align-items: center; */
        padding-left: 30px;
        margin-bottom: 20px;
    }
    
    .user1 .icon1 {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .user1 .name,
    .user1 .sex,
    .user1 .idCard,
    .user1 .phone {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        position: absolute;
        top: 31px;
        left: 30px;
        line-height: 18px;
    }
    
    .user1 .name {
        margin-left: 7px;
    }
    
    .user1 .sex {
        margin-left: 20px;
    }
    
    .user1 .idCard {
        margin-left: 20px;
    }
    
    .user1 .phone {
        margin-left: 20px;
    }
    
    .user1 .revise {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        margin-left: 10px;
        text-decoration: underline;
        cursor: pointer;
    }
    /*
.user1 .ts {
  position: absolute;
  left: 0px;
  line-height: 30px;
  top: 30px;
} */
    
    .user2 {
        height: 90px;
    }
    
    .user .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .user .name,
    .user .sex,
    .user .idCard,
    .user .phone {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
    }
    
    .user .idCard span,
    .user .phone span {
        font-weight: 400;
    }
    
    .user .name {
        margin-left: 7px;
    }
    
    .user .sex {
        margin-left: 20px;
    }
    
    .user .idCard {
        margin-left: 20px;
    }
    
    .user .phone {
        margin-left: 20px;
    }
    
    .user>.hint {
        position: absolute;
        top: 60px;
        font-size: 16px;
        font-weight: 400;
        color: #ff000f;
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #eaeaea;
        display: flex;
        align-items: center;
    }
    
    .breadNav p {
        width: 1180px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
    }
    
    .line {
        width: 95%;
        margin: 20px auto;
        height: 1px;
        background: #ccc;
        margin: 20px 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/orderList/details.vue